"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _variables = require("../common/variables.js");

var _useTheme = _interopRequireDefault(require("../useTheme"));

var _templateObject, _templateObject2, _templateObject3;

var _excluded = ["inheritColor", "disabled", "icon", "iconPosition", "href", "newWindow", "onClick", "margin", "tabIndex", "children"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var LinkContent = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var iconPosition = _ref.iconPosition,
      icon = _ref.icon,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, iconPosition === "after" && children, icon && /*#__PURE__*/_react["default"].createElement(LinkIconContainer, {
    iconPosition: iconPosition
  }, typeof icon === "string" ? /*#__PURE__*/_react["default"].createElement(LinkIcon, {
    src: icon
  }) : icon), iconPosition === "before" && children);
});

var DxcLink = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var _ref2$inheritColor = _ref2.inheritColor,
      inheritColor = _ref2$inheritColor === void 0 ? false : _ref2$inheritColor,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      icon = _ref2.icon,
      _ref2$iconPosition = _ref2.iconPosition,
      iconPosition = _ref2$iconPosition === void 0 ? "before" : _ref2$iconPosition,
      _ref2$href = _ref2.href,
      href = _ref2$href === void 0 ? "" : _ref2$href,
      _ref2$newWindow = _ref2.newWindow,
      newWindow = _ref2$newWindow === void 0 ? false : _ref2$newWindow,
      onClick = _ref2.onClick,
      margin = _ref2.margin,
      _ref2$tabIndex = _ref2.tabIndex,
      tabIndex = _ref2$tabIndex === void 0 ? 0 : _ref2$tabIndex,
      children = _ref2.children,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  var colorsTheme = (0, _useTheme["default"])();
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: colorsTheme.link
  }, /*#__PURE__*/_react["default"].createElement(StyledLink, (0, _extends2["default"])({
    as: href ? "a" : "button",
    tabIndex: tabIndex,
    onClick: !disabled ? onClick : undefined,
    href: !disabled && href ? href : undefined,
    target: href ? newWindow ? "_blank" : "_self" : undefined,
    disabled: disabled,
    inheritColor: inheritColor,
    margin: margin,
    ref: ref
  }, otherProps), /*#__PURE__*/_react["default"].createElement(LinkContent, {
    iconPosition: iconPosition,
    icon: icon,
    children: children
  })));
});

var StyledLink = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: inline-flex;\n  align-items: baseline;\n\n  margin: ", ";\n  margin-top: ", ";\n  margin-right: ", ";\n  margin-bottom: ", ";\n  margin-left: ", ";\n\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  font-size: ", ";\n  font-weight: ", ";\n  font-style: ", ";\n  font-family: ", ";\n  text-decoration-color: transparent;\n  width: fit-content;\n\n  ", "\n  ", "\n  color: ", ";\n  ", "\n\n  &:visited {\n    color: ", ";\n    &:hover {\n      ", "\n    }\n  }\n  &:hover {\n    ", "\n  }\n  &:focus {\n    border-radius: 2px;\n    outline: 2px solid ", ";\n    ", "\n  }\n  &:active {\n    ", "\n  }\n"])), function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) !== "object" ? _variables.spaces[props.margin] : "0px";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.top ? _variables.spaces[props.margin.top] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.right ? _variables.spaces[props.margin.right] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.bottom ? _variables.spaces[props.margin.bottom] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.left ? _variables.spaces[props.margin.left] : "";
}, function (props) {
  return props.theme.fontSize;
}, function (props) {
  return props.theme.fontWeight;
}, function (props) {
  return props.theme.fontStyle;
}, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return "padding-bottom: ".concat(props.theme.underlineSpacing, ";\n     border-bottom: ").concat(props.theme.underlineThickness, " ").concat(props.theme.underlineStyle, " transparent;");
}, function (props) {
  return props.disabled && "cursor: default;";
}, function (props) {
  return props.inheritColor ? "inherit" : !props.disabled ? props.theme.fontColor : props.theme.disabledColor;
}, function (props) {
  return props.disabled ? "pointer-events: none;" : "";
}, function (props) {
  return !props.inheritColor && !props.disabled ? props.theme.visitedFontColor : "";
}, function (props) {
  return "color: ".concat(props.theme.visitedFontColor, ";\n         border-bottom-color: ").concat(props.theme.visitedUnderlineColor, ";");
}, function (props) {
  return "color: ".concat(props.theme.hoverFontColor, ";\n       border-bottom-color: ").concat(props.theme.hoverUnderlineColor, ";\n       cursor: pointer;");
}, function (props) {
  return props.theme.focusColor;
}, function (props) {
  return props.disabled && "outline: none";
}, function (props) {
  return "color: ".concat(props.theme.activeFontColor, " !important;\n       border-bottom-color: ").concat(props.theme.activeUnderlineColor, " !important;");
});

var LinkIcon = _styledComponents["default"].img(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])([""])));

var LinkIconContainer = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  width: ", ";\n  height: ", ";\n  ", ";\n  overflow: hidden;\n  align-self: center;\n\n  img,\n  svg {\n    height: 100%;\n    width: 100%;\n  }\n"])), function (props) {
  return props.theme.iconSize;
}, function (props) {
  return props.theme.iconSize;
}, function (props) {
  return "".concat(props.iconPosition === "before" ? "margin-right" : "margin-left", ": ").concat(props.theme.iconSpacing);
});

var _default = DxcLink;
exports["default"] = _default;